import { deleteRequest, get, post } from './_defaults/fetch.js';

export const getGpts = ({ params, config }) => get('/gpts', { params, ...config });
export const getGpt = ({ id, params, config }) => get(`/gpts/${id}`, { params, ...config });
export const createGpt = ({ data, config }) => { post('/gpts', data, config) };
export const updateGpt = ({ id, data, config }) => post(`/gpts/${id}`, data, config);
export const deleteGpt = ({ id, config }) => deleteRequest(`/gpts/${id}`, null, config);
